<style lang="scss" scoped>
@import '$vars';

.medical-history-data {
  @apply w-full pt-4 pb-2 mb-1;
  border-bottom: 1px solid rgb(240, 240, 240);

  &__title {
    @apply m-0 p-0 mb-1;
    @apply uppercase text-grayDark;
    font-family: $font1;
    font-size: 0.7rem;
    font-weight: 600;
  }

  &__content {
    font-size: 0.75rem;
  }
}
</style>

<template>
  <section class="medical-history-data">
    <h3 class="medical-history-data__title">
      {{ title }}
    </h3>

    <div class="medical-history-data__content">
      {{ content }}
    </div>
  </section>
</template>

<script>
export default {
  name: 'MedicalHistoryData',

  props: {
    title: {
      type: String,
      required: true
    },

    content: {
      type: String,
      required: true
    }
  }
}
</script>
